import PropTypes from 'prop-types';

import ButtonIcon from '@/atoms/ButtonIcon/ButtonIcon';

export default function SearchInputText({ value, onChange, onSearch }) {
  const handleEnterKey = (e) => {
    if (e?.nativeEvent.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="aaco-input aaco-text-input">
      <input
        type="text"
        className="bg-transparent border-b-1 w-full border-b-acacia pb-[14px] font-heading text-h5-mobile text-black placeholder:text-black outline-none focus:border-b-2 focus:border-b-eucalyptus"
        placeholder="Search"
        value={value}
        onChange={onChange}
        onKeyDown={handleEnterKey}
      />
      <ButtonIcon
        width={23}
        height={23}
        icon="search"
        iconStyle="text-acacia "
        style="absolute right-0 bottom-[14px] border-0 h-fit w-fit"
        onClick={onSearch}
      />
    </div>
  );
}

SearchInputText.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

SearchInputText.defaultProps = {
  value: '',
};
